import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, defaultLandingForRole } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Attendance from "@/pages/Attendance";
import Leaves from "@/pages/Leaves";
import Payroll from "@/pages/Payroll";
import Invoices from "@/pages/Invoices";
import InvoiceForm from "@/pages/InvoiceForm";
import InvoiceView from "@/pages/InvoiceView";
import SuperAdminDashboard from "@/pages/superadmin/SuperAdminDashboard";
import Companies from "@/pages/superadmin/Companies";
import Reports from "@/pages/superadmin/Reports";
import MeDashboard from "@/pages/employee/MeDashboard";
import MyProfile from "@/pages/employee/MyProfile";
import MyAttendance from "@/pages/employee/MyAttendance";
import MyLeaves from "@/pages/employee/MyLeaves";
import MyPayslips from "@/pages/employee/MyPayslips";
import { Toaster } from "@/components/ui/sonner";

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={defaultLandingForRole(user.role)} replace />;
  return children;
}

const T = (Page, roles) => (
  <ProtectedRoute roles={roles}><Layout>{Page}</Layout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/change-password" element={
              <ProtectedRoute><ChangePassword /></ProtectedRoute>
            } />

            {/* Super Admin */}
            <Route path="/super-admin"            element={T(<SuperAdminDashboard />, ["super_admin"])} />
            <Route path="/super-admin/companies"  element={T(<Companies />,          ["super_admin"])} />
            <Route path="/super-admin/reports"    element={T(<Reports />,            ["super_admin"])} />

            {/* Tenant Admin / HR */}
            <Route path="/"           element={T(<Dashboard />,    ["admin", "hr"])} />
            <Route path="/employees"  element={T(<Employees />,    ["admin", "hr"])} />
            <Route path="/attendance" element={T(<Attendance />,   ["admin", "hr"])} />
            <Route path="/leaves"     element={T(<Leaves />,       ["admin", "hr"])} />
            <Route path="/payroll"    element={T(<Payroll />,      ["admin", "hr"])} />
            <Route path="/invoices"   element={T(<Invoices />,     ["admin", "hr"])} />
            <Route path="/invoices/new"      element={T(<InvoiceForm />, ["admin", "hr"])} />
            <Route path="/invoices/:id"      element={T(<InvoiceView />, ["admin", "hr"])} />
            <Route path="/invoices/:id/edit" element={T(<InvoiceForm />, ["admin", "hr"])} />

            {/* Employee self-service */}
            <Route path="/me"            element={T(<MeDashboard />,  ["employee"])} />
            <Route path="/me/profile"    element={T(<MyProfile />,    ["employee"])} />
            <Route path="/me/attendance" element={T(<MyAttendance />, ["employee"])} />
            <Route path="/me/leaves"     element={T(<MyLeaves />,     ["employee"])} />
            <Route path="/me/payslips"   element={T(<MyPayslips />,   ["employee"])} />

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
